module.exports = __webpack_public_path__ + "847541504914fd33810e70a0ea73177e.ico";